import React from 'react';
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    LinearProgress,
    Typography,
    makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    progressWrap: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        marginTop: theme.spacing(1),
    },
    percent: {
        minWidth: 48,
        textAlign: 'right',
        fontWeight: 600,
        color: '#1C375D',
    },
}));

const PanelDownloadProgressDialog = ({ open, progress = 0, totalCount = 0 }) => {
    const classes = useStyles();

    return (
        <Dialog open={open} maxWidth="xs" fullWidth disableEscapeKeyDown>
            <DialogTitle>Downloading Panel Data</DialogTitle>
            <DialogContent>
                <Typography variant="body2" color="textSecondary">
                    Exporting {Number(totalCount || 0).toLocaleString()} panel records to CSV.
                </Typography>
                <Box className={classes.progressWrap}>
                    <Box width="100%">
                        <LinearProgress variant="determinate" value={progress} />
                    </Box>
                    <Typography className={classes.percent} variant="body2">
                        {progress}%
                    </Typography>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default PanelDownloadProgressDialog;
